var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.87 3.727a1.498 1.498 0 0 1 2.26 0l.053.07 4.225 6.18h.001l.02-.015 4.28-3.259a1 1 0 0 1 .119-.074 1.5 1.5 0 0 1 2.157 1.554l-1.32 9.948a.75.75 0 0 1-.743.651H2.078a.75.75 0 0 1-.743-.651L.015 8.183A1.5 1.5 0 0 1 2.172 6.63a1 1 0 0 1 .118.074L6.571 9.96l.02.016h.002l4.224-6.18.054-.069Zm1.13.997-4.17 6.1a1.5 1.5 0 0 1-2.175.324l-4.152-3.16 1.232 9.294h18.53l1.233-9.293-4.153 3.16a1.5 1.5 0 0 1-2.175-.326L12 4.723ZM1.5 21.032a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKing);
export default __webpack_public_path__ + "static/media/king.335440863db6794466a5b0b8bcde0c9d.svg";
export { ForwardRef as ReactComponent };